/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = /** @type {(inputs: {}) => string} */ () => {
	return `Auf GetYourGuide entdecken`
};

const en_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = /** @type {(inputs: {}) => string} */ () => {
	return `Discover on GetYourGuide`
};

const es_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = /** @type {(inputs: {}) => string} */ () => {
	return `Descubrir en GetYourGuide`
};

const fr_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrir sur GetYourGuide`
};

const it_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = /** @type {(inputs: {}) => string} */ () => {
	return `Scopri su GetYourGuide`
};

const nl_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ontdek het op GetYourGuide`
};

const pt_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = /** @type {(inputs: {}) => string} */ () => {
	return `Descobrir em GetYourGuide`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label", locale)
	if (locale === "de") return de_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs)
	if (locale === "en") return en_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs)
	if (locale === "es") return es_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs)
	if (locale === "fr") return fr_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs)
	if (locale === "it") return it_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs)
	if (locale === "nl") return nl_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs)
	return pt_poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label(inputs)
};